import { Component, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { List as ImmutableList } from 'immutable';
import { List } from '../../constants-types/PiList.model';
import { Folder } from '../../core-data-model/Folder.model';
import { FoldersDataService } from '../../core-services/Folders.dataservice';
import { DateFormatUtility } from '../../core-utilities/DateFormat.utility';
import { Util } from '../../core-utilities/Util';
import { TranslationService } from '../../translations';

@Component({
    selector: 'folder-typeahead',
    template: `
        <array-to-single-model [(ngModel)]="folder">
            <ok-pillbox-with-typeahead
                #childComponent
                [typeaheadList]="folderPossibilities"
                (typeaheadOnTextChange)="filterFolderPossibilities($event)"
                [typeaheadPlaceholder]="
                    TR.key('label.folders.search.for.folder')
                "
                [pillboxLimit]="1"
                [searchStyling]="true"
                [isDisabled]="isDisabled"
            >
                <ng-template #pillbox let-item="item">
                    {{ displayFunction(item) }}
                </ng-template>
                <ng-template #typeahead let-item="item">
                    {{ displayFunction(item) }}
                </ng-template>
            </ok-pillbox-with-typeahead>
        </array-to-single-model>
    `,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FolderTypeaheadComponent,
            multi: true
        }
    ],
    standalone: false
})
export class FolderTypeaheadComponent implements ControlValueAccessor {
    // This is what will be bound to externally
    _folder: Folder;
    // Value needed by ControlValueAccessor - it is a no-op that is replaced by framework
    propagateChange = (_: any) => {
        /* No change propagated */
    };
    folderPossibilities: List<Folder> = ImmutableList();
    textInBox: string;

    @Input()
    isDisabled = false;

    constructor(
        public TR: TranslationService,
        public util: Util,
        public date: DateFormatUtility,
        private foldersService: FoldersDataService
    ) {}

    filterFolderPossibilities(textInBox: string): void {
        if (!textInBox || !textInBox.trim()) {
            this.folderPossibilities = ImmutableList();
            return;
        }
        this.folderPossibilities = ImmutableList(
            this.foldersService
                .findAllWithPartialPathFromFolderSet(textInBox)
                .slice(0, 5)
        );
    }

    displayFunction(folder: Folder): string {
        if (folder) {
            return this.foldersService.getPathForFolder(folder.id);
        }
        return '';
    }

    /* Meet ControlValueAccessor Interface */
    get folder(): Folder {
        return this._folder;
    }
    set folder(val: Folder) {
        this._folder = val || null;
        this.propagateChange(this._folder);
    }
    // Do NOT propagate changes up here
    writeValue(value: Folder): void {
        this._folder = value;
    }
    registerOnChange(fn: any): void {
        this.propagateChange = (changed) => fn.call(this, changed);
    }
    registerOnTouched(): void {
        /* No callback function registered OnTouched */
    }
    /** ***************************************/
}
